import { Calendar } from 'primereact/calendar'
import React, { useContext, useEffect, useState } from 'react'
import AutoCompleteDropdown from './AutoCompleteDropdown'
import { getCalendarioMensual } from '../../../API/CalendarioOperativo/CalendarioOperativoRequest';
import { ConfigContext } from '../../Context/ConfigContext/ConfigContext';

// TIPOS DE CALENDARIOS
// normal 
// Muestra un calendario mensual
// operativo
// Muestra un calendario segun mes operativo

const CalendarioOperativo = ({ dates, setDates, loading = false, getInfo = null, dateFormat = 'dd/mm/yy', tipo = 'mesCalendario' }) => {

    // const [periodoSelect, setPeriodoSelect] = useState(null);
    // const [periodos, setPeriodos] = useState([]);

    const [periodoSelect, setPeriodoSelect] = useState(null)
    const [periodo, setPeriodos] = useState([])
    const [idCalendario, setIdCalendario] = useState(null)

    const { config } = useContext(ConfigContext)

    const filtrarMeses = async (Mes) => {
        if (Mes?.IdMes) {
            setPeriodoSelect(Mes)
            let mesSeleccionado = periodo.filter((e) => Mes.IdMes === e.IdMes)
            // console.log({mesSeleccionado, Mes});
            let rangoFechaInicio = new Date(mesSeleccionado[0]?.InicioMes)
            let rangoFechaFinal = new Date(mesSeleccionado[0]?.FinMes)


            // let datosFechas2 = [mesSeleccionado[0]?.FechaInicio, mesSeleccionado[0]?.FechaFinal]
            // console.log([rangoFechaInicio, rangoFechaFinal]);
            let datosFechas = [rangoFechaInicio, rangoFechaFinal]
            setDates(datosFechas)

        } else {
            setPeriodoSelect(null)
            setDates([])
        }


        // setIdCalendario(mesSeleccionado[0]?.IdMes)

    }

    const AsignarFechasCalendarioOperativo = (calendarioMeses) => {

        let nowDate = new Date()
        let year = new Date().getFullYear();
        let mes = new Date().getMonth() + 1
        let a = calendarioMeses.filter((e) => mes === e.NoMes && year === e.Anio)
        let semA = a.filter((s) => {
            if ((new Date(s.InicioMes) <= nowDate) && (new Date(s.FinMes) >= nowDate)) {
                return s
            }
        })
        let mesAnterior = mes === 1 ? (12) : new Date().getMonth()
        let anioAnterior = mes === 1 ? year - 1 : year
        let b = calendarioMeses.filter((e) => mesAnterior === e.NoMes && anioAnterior === e.Anio)
        // console.log({ a, b });
        let semB = b.filter((s) => {
            if ((new Date(s.InicioMes) <= nowDate) && (new Date(s.FinMes) >= nowDate)) {

                return s
            }

        })
        // console.log({ semA, semB });

        let idM
        // SIGUIENTE MES OPERATIVO
        if (semA.length <= 0 && semB.length <= 0) {
            let mesSiguiente = mes === 12 ? (1) : (mes + 1)
            let anioSiguiente = mes === 12 ? year + 1 : year
            let c = calendarioMeses.filter((e) => mesSiguiente === e.NoMes && anioSiguiente === e.Anio)
            let semC = c.filter((s) => {
                if (new Date((s.InicioMes) <= nowDate) && (new Date(s.FinMes) >= nowDate)) {
                    return s
                }
            })
            idM = semC[0]
            //setPeriodoSelect(semC[0].IdMes)
            setPeriodoSelect(semC[0])

        } else {

            if (new Date() <= (new Date(b[b.length - 1]?.FinMes))) {
                // setMes(semB[0].IdMes)
                idM = semB[0]
            } else {
                // console.log('semA', semA);
                idM = semA[0]
                // setMes(semA[0].IdMes)
            }
        }
        setPeriodoSelect(idM)
        setIdCalendario(idM)
        // setIdCalendario(idM)
        setDates([new Date(idM?.InicioMes), new Date(idM?.FinMes)])

        calendarioMeses.sort((a, b) => {
            if (a.Anio !== b.Anio) {
                return a.Anio - b.Anio;
            }
        })
        setPeriodos(calendarioMeses)
    }

    const getInfoCalendarOperativo = async () => {
        const t = await getCalendarioMensual();
        let calendar = t.map((item) => {
            let Nombre = config.language === 'es' ? item.Nombre : item.Name;
            return {
                ...item,
                Nombre,
            }
        })
        setPeriodos(calendar);
        AsignarFechasCalendarioOperativo(t);
    }

    const getInfoCalendarioMensual = async () => {
        const t = await getCalendarioMensual();
        let calendar = t.map((item) => {
            let Nombre = config.language === 'es'
                ? item.MesEsLargo
                : item.MesEnLargo;

            return {
                ...item,
                Nombre: `${Nombre} ${item.Anio}`,
                InicioMes: new Date(item?.Anio, item.NoMes - 1, 1),
                FinMes: new Date(item?.Anio, item.NoMes, 0)
            }
        })

        calendar.sort((a, b) => {
            if (a.Anio !== b.Anio) {
                return b.Anio - a.Anio;
            }

            return b.NoMes - a.NoMes;
        });
        setPeriodos(calendar);
        let hoy = new Date()
        let mesActual = calendar.filter(item => item.NoMes === hoy.getMonth() + 1  && item.Anio === hoy.getFullYear())
        if (mesActual?.length > 0) {
            setPeriodoSelect(mesActual[0])
            setDates([mesActual[0]?.InicioMes, mesActual[0]?.FinMes])
        }
    }

    useEffect(() => {
        switch (tipo.toLowerCase()) {
            case 'mesoperativo':
                getInfoCalendarOperativo();
                break;
            case 'mescalendario':
                getInfoCalendarioMensual();
                break;

            default:
                getInfoCalendarioMensual();
                break;
        }
    }, [config.language])

    useEffect(() => {
        if (dates && dates.length === 2 && dates[0] && dates[1]) {
            getInfo()
        }
    }, [dates])

    // console.log("periodoSelect:", periodoSelect);
    // console.log("Nombre visible:", periodoSelect?.Nombre);

    return (
        <div className='gap' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <AutoCompleteDropdown
                value={periodoSelect}
                items={periodo}
                field='Nombre'
                selectedItemTemplate={(option) => option?.Nombre}
                itemTemplate={(option) => option?.Nombre}
                onValueChange={(e) => filtrarMeses(e.value)}
            />
            <Calendar
                value={dates}
                onChange={(e) => setDates(e.value)}
                showButtonBar
                showIcon
                icon={() => <i className="pi pi-calendar" style={{ color: "#2f659d" }} />}
                selectionMode='range'
                //style={{ height: 47, width: 245, marginBottom: 2, }}
                dateFormat={dateFormat}
                disabled={loading}
            />
        </div>
    )
}

export default CalendarioOperativo